/**
 * Registration form (/register) — French and Italian UI strings.
 * Stored values (country names, payment method keys, etc.) stay as in the original form for API compatibility.
 */

export const registerFormFr = {
  pageTitle: 'Devenir Membre - Inscription Juventus Official Fan Club Oltre Frontiera',
  validationTitle: 'Erreurs de validation:',
  sectionPersonal: 'Madame ou Monsieur',
  labelCivilite: 'Civilité *',
  madame: 'Madame',
  monsieur: 'Monsieur',
  labelLastName: 'Nom *',
  labelFirstName: 'Prénom *',
  placeholderNameDoc: "Comme indiqué sur la pièce d'identité",
  labelSexe: 'Sexe *',
  sexeHomme: 'Homme',
  sexeFemme: 'Femme',
  labelDob: 'Date de naissance *',
  sectionBirth: 'Lieu de naissance',
  labelBirthCountry: 'Pays de naissance *',
  selectCountry: 'Sélectionnez un pays',
  labelBirthCanton: 'Canton ou département de naissance',
  selectDot: 'Sélectionnez...',
  labelBirthCity: 'Ville de naissance *',
  placeholderBirthCity: 'Exemple : Montreux',
  birthSubdivisionPlaceholderOther:
    'Subdivision administrative (cantone, région, département, province …)',
  sectionEmailMobile: 'Email et Mobile',
  labelEmail: 'Email *',
  placeholderEmail: 'votre@email.com',
  emailHelp: "L'email sera votre identifiant pour la connexion",
  labelMobile: 'Mobile *',
  phoneFormat: '+indicatif international, indicatif régional, numéro',
  labelPassword: 'Mot de passe *',
  placeholderPassword: 'Minimum 6 caractères',
  labelConfirmPassword: 'Confirmer le mot de passe *',
  placeholderConfirmPassword: 'Confirmer le mot de passe',
  labelCodice: 'Code fiscal',
  placeholderCodice: 'Codice fiscale',
  codiceHelp:
    "<strong>Obligatoire si résident en Italie.</strong> Pour les résidents hors Italie, il est utile de le fournir si en possession.",
  sectionAddress: 'Adresse de résidence',
  labelStreet: 'Rue et numéro de résidence *',
  placeholderStreet: 'Rue de la Gare',
  placeholderStreetNo: 'N°',
  labelPostal: 'NPA / CP / ZIP de résidence *',
  labelCityResidence: 'Ville de résidence *',
  placeholderCity: 'Lausanne',
  labelResidenceCanton: 'Canton ou département de résidence',
  labelResidenceCountry: 'Pays de résidence *',
  sectionIdentity: 'IDENTITÉ',
  labelIdType: "Type de document d'identité *",
  idCard: "Carte d'identité",
  passport: 'Passeport',
  labelIdNumber: "Numéro de la pièce d'identité *",
  placeholderIdNumber: 'Numéro du document',
  labelIdExpiry: "Échéance pièce d'identité *",
  labelIdIssueDate: "Date d'émission *",
  labelIdIssueCanton: "Canton/Département d'émission *",
  placeholderIdIssueCanton: 'VD, VS, GE, 75, MI…',
  labelIdIssueCity: "Commune/localité d'émission *",
  placeholderIdIssueCity: 'Exemple : Lausanne',
  labelIdCopy: "Copie pièce d'identité *",
  uploadIdInstructions:
    "📤 <strong>TÉLÉCHARGER</strong> - Mettre 2 fichiers à cause des cartes d'identité",
  fileHintFront:
    'Recto en couleur, 15 MB maximum, format jpg, png, heic, heif ou pdf. Les photos JPG/PNG/HEIC sont compressées automatiquement avant envoi lorsque le navigateur le permet.',
  labelIdVerso: "Copie pièce d'identité (Verso)",
  idVersoHint: "Verso de la carte d'identité en couleur (JPG/PNG/HEIC compressés automatiquement lorsque possible).",
  sectionJuveCard: 'VOTRE JUVENTUS CARD OU TESSERA DEL TIFOSO',
  labelHasTessera: 'Je suis en possession de la Juventus Card®',
  yes: 'Oui',
  no: 'Non',
  labelTesseraNo: 'N° Juventus Card® *',
  tesseraPlaceholder: 'Toujours 0143 + 8 chiffres',
  tesseraFormat: 'Format: 0143 suivi de 8 chiffres',
  labelTesseraExpiry: 'Échéance de la Juventus Card® *',
  labelTesseraPin: 'Numéro PIN *',
  tesseraPinPlaceholder: 'Code PIN de la carte',
  labelTesseraCopy: 'Copie de la Juventus Card® *',
  tesseraUpload: '📤 <strong>TÉLÉCHARGER</strong>',
  tesseraSmall: 'Copie en couleur, 15 MB maximum (JPG/PNG/HEIC compressés automatiquement lorsque possible).',
  wantTessera: 'Voulez-vous faire la demande de Juventus Card ?',
  tesseraInfoBox:
    '✅ La demande de Juventus Card sera traitée après votre inscription.<br/>Prix: 20 CHF ou 20 € (paiement séparé)',
  sectionSubscription: 'ABONNEMENT',
  labelHasSubscription: 'Je suis abonné aux matchs®',
  labelTribune: 'Tribune® *',
  selectTribune: 'Sélectionnez votre tribune',
  labelSettore: 'Secteur® *',
  settoreHint: '101 à 126 (sauf 110), puis 201 à 232 (sauf 211 et 212)',
  labelFila: 'Rangée® *',
  placeholderFila: 'Numéro de rangée',
  labelPosto: 'Place *',
  postoHint: 'Numéro de place: 1 à 58',
  sectionBW: 'CARTE BLACK & WHITE OU J1897',
  labelHasBW: 'Je suis en possession de la carte Black & White ou J1897*',
  labelBwNumber: 'Numéro carte Black & White ou J1897* *',
  placeholderCardNo: 'Numéro de carte',
  labelBwExpiry: 'Échéance de la carte Black & White ou J1897* *',
  labelBwCopy: 'Copie de la carte Black & White ou J1897* *',
  sectionConsents: 'CONDITIONS GÉNÉRALES ET CONFIDENTIALITÉ',
  marketingTitle: 'Marketing*',
  profilingTitle: 'Promotion*',
  imageTitle: "Utilisation de l'image*",
  newsletterTitle: 'Newsletter',
  consentNewsletterPrev:
    'Je souhaite recevoir la newsletter et les informations sur les événements du club Oltre Frontiera.',
  consentNewsletterExp:
    "En acceptant, vous recevrez par e-mail les actualités, événements et informations du Juventus Official Fan Club Oltre Frontiera. Vous pourrez retirer ce consentement à tout moment depuis votre profil membre.",
  consentMarketingPrev:
    'au traitement des propres données de la part de la Juventus F.C. S.p.A. avec comme but la commercialisation...',
  consentMarketingExp:
    "au traitement des propres données de la part de la Juventus F.C. S.p.A. avec comme but la commercialisation comme définies en l'informative, ici inclus le contrôle de la satisfaction du client, sondages de marché, la promotion et proposition, de la part de Juventus, par l'envoi de brefs messages de notification e-mail, SMS, newsletter, c'est-à-dire par modalités traditionnelles, de produits et/ou services, inhérents à la Juventus ou produits et services offerts par les partenaires de la Juventus.",
  consentProfilingPrev:
    "au traitement des propres données de la part de la Juventus F.C. S.p.A pour une activité d'étude et ou analyse de marché...",
  consentProfilingExp:
    "au traitement des propres données de la part de la Juventus F.C. S.p.A pour une activité d'étude et ou analyse de marché finalisée à recevoir des promotions, escomptes et communications visées basés sur les données fournies.",
  consentImagePrev:
    'Donne son consentement afin que les photos et/ou vidéos qui le concernent, qu\'elles aient été prises par la Juventus...',
  consentImageExp:
    "Donne son consentement afin que les photos et/ou vidéos qui le concernent, qu'elles aient été prises par la Juventus durant des évènements sportifs et/ou autres évènements organisés par ou pour la Juventus dans le cadre du projet Juventus Official Fan Club, auxquels le membre prend part, et/ou les images qu'elles aient été envoyées par le membre Juventus Official Fan Club à la Juventus, soient utilisées par cette dernière à des fins publicitaires et promotionnelles, sous-entendant qu'avec de telles expressions, la possibilité d'utiliser les dites images photographiques et/ou dans les campagnes publicitaires de la Juventus à travers l'exposition et la diffusion des dites images sur les sites de la Juventus ou à travers autres canaux de communication de la Juventus tel que les réseaux sociaux de la Juventus et éventuellement d'autres moyens.",
  accept: "J'accepte",
  refuse: 'Je refuse',
  sectionParent: '⚠️ COORDONNÉES PARENT (Enfant mineur)',
  parentNote:
    "Si l'enfant est mineur, nous devons demander ces informations (juste 1 parent) avec copie de la pièce d'identité du parent.",
  labelParentLastName: 'Nom parent *',
  labelParentFirstName: 'Prénom parent *',
  placeholderParentLast: 'Nom du parent',
  placeholderParentFirst: 'Prénom du parent',
  labelParentSexe: 'Sexe parent *',
  labelParentDob: 'Date de naissance parent *',
  labelParentPhone: 'Téléphone mobile parent *',
  labelParentEmail: 'Email parent *',
  parentBirthSubtitle: 'Lieu de naissance parent',
  labelVille: 'Ville *',
  labelCantonRegion: 'Canton / Région / Département / Province *',
  labelPays: 'Pays *',
  placeholderVilleNaissance: 'Ville de naissance',
  placeholderPays: 'Suisse, Italie...',
  labelParentId: "Pièce d'identité du parent *",
  parentIdUpload: "📤 <strong>TÉLÉCHARGER</strong> la pièce d'identité du parent",
  parentIdSmall:
    'Copie recto/verso en couleur, 15 MB maximum (JPG/PNG/HEIC compressés automatiquement lorsque possible).',
  sectionOtherClub: 'Autre JOFC fan club*',
  otherClubQ: "Êtes-vous membre d'un autre Juventus Official Fan Club ?",
  otherClubYes: "Je suis membre d'un autre fan club",
  otherClubNo: "Je ne suis pas membre d'un autre fan club",
  otherClubLegal:
    "<strong>Une personne ne peut être membre que d'un seul Juventus Official Fan Club.</strong> Si vous répondez oui à cette question, vous devez demander personnellement à votre précédent fan club de vous désinscrire auprès de la Juventus. Dès réception de votre demande, le fan club est dans l'obligation de vous retirer de sa liste de membres à Turin dans les 24 heures.",
  importantUnsub:
    "⚠️ <strong>IMPORTANT:</strong> Vous devez impérativement demander votre désinscription à votre ancien fan club avant de finaliser cette inscription.",
  checkboxUnsub: "✓ J'ai demandé ma désinscription à mon ancien fan club",
  membershipChoiceTitle: "CHOIX DU TYPE D'INSCRIPTION",
  eligibilityIntro: 'Selon votre date de naissance:',
  eligUnder5: 'Vous êtes éligible à la cotisation Under 5 (gratuit).',
  eligUnder14: 'Vous êtes éligible à la cotisation Under 14.',
  eligAdult: 'Vous êtes éligible à la cotisation JOFC Adult.',
  labelYourMembership: 'Votre cotisation*',
  membershipOptAdult:
    '<p><strong>JOFC Adult — 40 CHF / 40 €</strong></p><p>Inclus : Membership Black &amp; White digitale gratuite + un porte-clé</p>',
  membershipOptUnder14:
    '<p><strong>Under 14 — 30 CHF / 30 €</strong></p><p>(né(e) après le 01.07.2013)</p><p>Inclus : Membership Junior + un bonnet</p>',
  membershipOptUnder5: '<p><strong>Under 5 — Gratuit (né(e) après le 01.07.2022)</strong></p>',
  membershipRightsNote:
    'Les droits détaillés par formule seront communiqués prochainement.',
  sectionPriceTitle: 'Prix cotisation saison 2026-2027',
  thPaymentMode: 'Mode de paiement',
  thAdult: 'JOFC Adult',
  thUnder14: 'Under 14',
  thUnder5: 'Under 5',
  thPriceChfEur: 'Prix CHF / Prix EUR',
  pricingRowEbanking: 'E-banking',
  pricingRowRevolut: '*Carte Revolut',
  pricingRowCredit: '*Carte de crédit',
  tableNoteSms: '*Envoyer un SMS ou WhatsApp au +41786289688',
  twintCell: '(au 0786289688)',
  pricingUnder5Cell: 'Gratuit',
  labelPaymentMode: 'Mode de paiement *',
  selectPayment: 'Sélectionnez votre mode de paiement',
  optGratuit: 'Gratuit (Under5)',
  optgroupEbanking: 'E-banking',
  optgroupTwint: 'Twint',
  optgroupRevolut: 'Carte Revolut',
  optgroupCredit: 'Carte de crédit',
  optEbanking: 'E-banking (CHF ou EUR)',
  optTwint: 'Twint (CHF uniquement)',
  optRevolut: 'Carte Revolut (CHF ou EUR)',
  optCredit: 'Carte de crédit (CHF ou EUR)',
  labelCurrency: 'Devise *',
  chfLabel: 'CHF (Francs Suisses)',
  eurLabel: 'EUR (Euros)',
  amountDue: 'Montant à payer:',
  tesseraExtra: ' + 20 CHF/EUR pour la Juventus Card',
  paymentInfoTitle: 'Informations de paiement:',
  paymentTwintLi: 'Twint:',
  paymentTwintContact: '+41 78 628 96 88 (ajouter aux contacts)',
  paymentIbanChf: 'IBAN CHF:',
  paymentIbanEur: 'IBAN EUR:',
  paymentBic: 'BIC:',
  paymentBenef: 'Bénéficiaire:',
  paymentBenefValue: 'Juventus Club Oltre Frontiera, 1820 Montreux',
  paymentRevolutNote:
    '📱 <strong>Pour Carte Revolut et Carte de crédit:</strong> Envoyer un SMS ou WhatsApp au +41786289688',
  sectionDischargeTitle: 'Décharge*',
  consentDischargePrev:
    "En m'inscrivant à JOFC Oltre Frontiera, je déclare que les données inscrites ci-dessus sont réelles...",
  consentDischargeExp:
    "En m'inscrivant à JOFC Oltre Frontiera, je déclare que les données inscrites ci-dessus sont réelles. En cas de falsification de mes données personnelles, je décharge JOFC Oltre Frontiera de toute responsabilité si la Juventus décide de m'exclure et ceci peu importe la raison. Ma cotisation annuelle versée ne sera pas remboursée au pro rata d'adhésion durant la saison en cours.",
  submitLoading: '⏳ Inscription en cours...',
  submitIdle: '✅ Valider mon inscription',
  formNoteSubmit:
    'En cliquant sur « Valider mon inscription », vous confirmez que toutes les informations fournies sont exactes et vous acceptez les conditions générales.',
  alreadyMember: 'Déjà membre?',
  linkLogin: 'Se connecter',
  altSociImage: 'Soci',
  alertSuccess:
    'Inscription réussie ! Un e-mail récapitulatif vient de vous être envoyé (noreply@oltrefrontiera.ch). Vous recevrez un second message lorsque l’administration aura validé votre dossier et votre paiement.',
  errorGenericSubmit: "Une erreur est survenue lors de l'inscription",
  errorPayloadTooLarge:
    "Les fichiers envoyés sont trop volumineux pour le serveur (limite côté hébergement). Réessayez avec des pièces jointes plus légères (par ex. photos en basse résolution ou PDF compressés, max. 15 Mo chacune). Si le problème continue, contactez le club : la configuration du serveur doit autoriser des requêtes d'upload plus grandes (ex. nginx : client_max_body_size).",
  errors: {
    civilite: 'La civilité est obligatoire',
    firstName: 'Le prénom est obligatoire',
    lastName: 'Le nom est obligatoire',
    sexe: 'Le sexe est obligatoire',
    dateOfBirth: 'La date de naissance est obligatoire',
    birthCountry: 'Le pays de naissance est obligatoire',
    birthCity: 'La ville de naissance est obligatoire',
    phone: 'Le téléphone mobile est obligatoire',
    email: "L'email est obligatoire",
    password: 'Le mot de passe est obligatoire',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    street: 'La rue est obligatoire',
    streetNumber: 'Le numéro de rue est obligatoire',
    city: 'La ville de résidence est obligatoire',
    postalCode: 'Le code postal est obligatoire',
    identityType: 'Le type de document est obligatoire',
    identityNumber: "Le numéro de pièce d'identité est obligatoire",
    identityExpiry: "L'échéance de la pièce d'identité est obligatoire",
    identityIssueDate: "La date d'émission de la pièce d'identité est obligatoire",
    identityIssueCanton: "Le canton ou département d'émission est obligatoire",
    identityIssueCity: "La commune ou localité d'émission est obligatoire",
    identityFileF: "La copie de la pièce d'identité (recto) est obligatoire",
    codiceItaly: 'Le Codice fiscale est obligatoire pour les résidents en Italie',
    tesseraNumber: 'Le numéro de la Juventus Card est obligatoire',
    tesseraExpiry: "L'échéance de la Juventus Card est obligatoire",
    tesseraPIN: 'Le PIN de la Juventus Card est obligatoire',
    tesseraFile: 'La copie de la Juventus Card est obligatoire',
    tribune: 'La tribune est obligatoire',
    settore: 'Le settore est obligatoire',
    fila: 'La fila (rangée) est obligatoire',
    posto: 'Le posto (place) est obligatoire',
    blackWhiteNumber: 'Le numéro de carte Black & White est obligatoire',
    blackWhiteExpiry: "L'échéance de la carte est obligatoire",
    blackWhiteFile: 'La copie de la carte est obligatoire',
    parentEmail: "L'email du parent est obligatoire",
    parentPhone: 'Le téléphone du parent est obligatoire',
    parentFirstName: 'Le prénom du parent est obligatoire',
    parentLastName: 'Le nom du parent est obligatoire',
    parentIdentityFile: "La copie de la pièce d'identité du parent est obligatoire",
    discharge: 'Vous devez accepter la décharge',
    membershipType: 'Vous devez choisir un type de cotisation',
    paymentMethod: 'Le mode de paiement est obligatoire',
    otherFanClub: "Veuillez répondre à la question sur l'autre fan club",
  },
};

export const registerFormIt = {
  pageTitle: 'Diventa socio - Iscrizione Juventus Official Fan Club Oltre Frontiera',
  validationTitle: 'Errori di validazione:',
  sectionPersonal: 'Signora o signore',
  labelCivilite: 'Titolo *',
  madame: 'Signora',
  monsieur: 'Signore',
  labelLastName: 'Cognome *',
  labelFirstName: 'Nome *',
  placeholderNameDoc: 'Come sul documento d’identità',
  labelSexe: 'Sesso *',
  sexeHomme: 'Uomo',
  sexeFemme: 'Donna',
  labelDob: 'Data di nascita *',
  sectionBirth: 'Luogo di nascita',
  labelBirthCountry: 'Paese di nascita *',
  selectCountry: 'Seleziona un paese',
  labelBirthCanton: 'Cantone o dipartimento di nascita',
  selectDot: 'Seleziona...',
  labelBirthCity: 'Città di nascita *',
  placeholderBirthCity: 'Es.: Montreux',
  birthSubdivisionPlaceholderOther:
    'Suddivisione amministrativa (cantone, regione, provincia…)',
  sectionEmailMobile: 'Email e cellulare',
  labelEmail: 'Email *',
  placeholderEmail: 'tua@email.com',
  emailHelp: 'L’email sarà il tuo identificativo per l’accesso',
  labelMobile: 'Cellulare *',
  phoneFormat: 'Formato: +prefisso internazionale, prefisso, numero',
  labelPassword: 'Password *',
  placeholderPassword: 'Minimo 6 caratteri',
  labelConfirmPassword: 'Conferma password *',
  placeholderConfirmPassword: 'Conferma la password',
  labelCodice: 'Codice fiscale',
  placeholderCodice: 'Codice fiscale',
  codiceHelp:
    '<strong>Obbligatorio se residente in Italia.</strong> Per i residenti fuori Italia è utile indicarlo se in possesso.',
  sectionAddress: 'Indirizzo di residenza',
  labelStreet: 'Via e numero di residenza *',
  placeholderStreet: 'Via Roma',
  placeholderStreetNo: 'N.',
  labelPostal: 'CAP / NPA / ZIP di residenza *',
  labelCityResidence: 'Città di residenza *',
  placeholderCity: 'Losanna',
  labelResidenceCanton: 'Cantone o dipartimento di residenza',
  labelResidenceCountry: 'Paese di residenza *',
  sectionIdentity: 'IDENTITÀ',
  labelIdType: 'Tipo di documento d’identità *',
  idCard: 'Carta d’identità',
  passport: 'Passaporto',
  labelIdNumber: 'Numero del documento d’identità *',
  placeholderIdNumber: 'Numero del documento',
  labelIdExpiry: 'Scadenza documento d’identità *',
  labelIdIssueDate: 'Data di emissione *',
  labelIdIssueCanton: 'Cantone/Dipartimento di emissione *',
  placeholderIdIssueCanton: 'VD, VS, GE, 75, MI…',
  labelIdIssueCity: 'Comune/località di emissione *',
  placeholderIdIssueCity: 'Es.: Losanna',
  labelIdCopy: 'Copia documento d’identità *',
  uploadIdInstructions:
    '📤 <strong>CARICA</strong> - Due file per le carte d’identità (fronte/retro)',
  fileHintFront:
    'Fronte a colori, max 15 MB, jpg, png, heic, heif o pdf. Le foto JPG/PNG/HEIC vengono compresse automaticamente prima dell’invio quando il browser lo consente.',
  labelIdVerso: 'Copia documento (retro)',
  idVersoHint: 'Retro della carta d’identità a colori (JPG/PNG/HEIC compressi automaticamente quando possibile).',
  sectionJuveCard: 'LA TUA JUVENTUS CARD O TESSERA DEL TIFOSO',
  labelHasTessera: 'Sono in possesso della Juventus Card®',
  yes: 'Sì',
  no: 'No',
  labelTesseraNo: 'N° Juventus Card® *',
  tesseraPlaceholder: 'Sempre 0143 + 8 cifre',
  tesseraFormat: 'Formato: 0143 seguito da 8 cifre',
  labelTesseraExpiry: 'Scadenza Juventus Card® *',
  labelTesseraPin: 'Numero PIN *',
  tesseraPinPlaceholder: 'PIN della carta',
  labelTesseraCopy: 'Copia della Juventus Card® *',
  tesseraUpload: '📤 <strong>CARICA</strong>',
  tesseraSmall: 'Copia a colori, max 15 MB (JPG/PNG/HEIC compressi automaticamente quando possibile).',
  wantTessera: 'Vuoi richiedere la Juventus Card?',
  tesseraInfoBox:
    '✅ La richiesta di Juventus Card sarà elaborata dopo l’iscrizione.<br/>Prezzo: 20 CHF o 20 € (pagamento separato)',
  sectionSubscription: 'ABBONAMENTO',
  labelHasSubscription: 'Sono abbonato alle partite®',
  labelTribune: 'Tribuna® *',
  selectTribune: 'Seleziona la tua tribuna',
  labelSettore: 'Settore® *',
  settoreHint: '101 a 126 (eccetto 110), poi 201 a 232 (eccetto 211 e 212)',
  labelFila: 'Fila® *',
  placeholderFila: 'Numero fila',
  labelPosto: 'Posto *',
  postoHint: 'Numero posto: da 1 a 58',
  sectionBW: 'CARTA BLACK & WHITE O J1897',
  labelHasBW: 'Sono in possesso della carta Black & White o J1897*',
  labelBwNumber: 'Numero carta Black & White o J1897* *',
  placeholderCardNo: 'Numero carta',
  labelBwExpiry: 'Scadenza carta Black & White o J1897* *',
  labelBwCopy: 'Copia carta Black & White o J1897* *',
  sectionConsents: 'CONDIZIONI GENERALI E PRIVACY',
  marketingTitle: 'Marketing*',
  profilingTitle: 'Profilazione*',
  imageTitle: 'Utilizzo dell’immagine*',
  newsletterTitle: 'Newsletter',
  consentNewsletterPrev:
    'Desidero ricevere la newsletter e le informazioni sugli eventi del club Oltre Frontiera.',
  consentNewsletterExp:
    'Accettando, riceverai via e-mail le novità, gli eventi e le informazioni del Juventus Official Fan Club Oltre Frontiera. Potrai revocare questo consenso in qualsiasi momento dal tuo profilo socio.',
  consentMarketingPrev:
    'al trattamento dei propri dati da parte di Juventus F.C. S.p.A. a fini di marketing...',
  consentMarketingExp:
    'al trattamento dei propri dati da parte di Juventus F.C. S.p.A. a fini di marketing come definito nell’informativa, inclusi controllo della soddisfazione del cliente, ricerche di mercato, promozioni e proposte da parte della Juventus tramite e-mail, SMS, newsletter e mezzi tradizionali, relativi a prodotti e/o servizi della Juventus o dei partner.',
  consentProfilingPrev:
    'al trattamento dei propri dati da parte di Juventus F.C. S.p.A. per studi e analisi di mercato...',
  consentProfilingExp:
    'al trattamento dei propri dati da parte di Juventus F.C. S.p.A. per studi e analisi di mercato finalizzati a ricevere promozioni, sconti e comunicazioni mirate in base ai dati forniti.',
  consentImagePrev:
    'Acconsente all’uso di foto e/o video che lo ritraggono, riprese dalla Juventus...',
  consentImageExp:
    'Acconsente all’uso di foto e/o video che lo ritraggono, riprese dalla Juventus durante eventi sportivi e altri eventi organizzati da o per la Juventus nell’ambito del progetto Juventus Official Fan Club, a cui il socio partecipa, e/o immagini inviate dal socio alla Juventus, per finalità pubblicitarie e promozionali, inclusa la diffusione sui siti e canali della Juventus (es. social).',
  accept: 'Accetto',
  refuse: 'Rifiuto',
  sectionParent: '⚠️ DATI GENITORE (minorenne)',
  parentNote:
    'Se il richiedente è minorenne, servono questi dati (un solo genitore) e copia del documento del genitore.',
  labelParentLastName: 'Cognome genitore *',
  labelParentFirstName: 'Nome genitore *',
  placeholderParentLast: 'Cognome',
  placeholderParentFirst: 'Nome',
  labelParentSexe: 'Sesso genitore *',
  labelParentDob: 'Data di nascita genitore *',
  labelParentPhone: 'Cellulare genitore *',
  labelParentEmail: 'Email genitore *',
  parentBirthSubtitle: 'Luogo di nascita genitore',
  labelVille: 'Città *',
  labelCantonRegion: 'Cantone / Regione / Dipartimento / Provincia *',
  labelPays: 'Paese *',
  placeholderVilleNaissance: 'Città di nascita',
  placeholderPays: 'Svizzera, Italia...',
  labelParentId: 'Documento d’identità del genitore *',
  parentIdUpload: '📤 <strong>CARICA</strong> il documento del genitore',
  parentIdSmall:
    'Copia fronte/retro a colori, max 15 MB (JPG/PNG/HEIC compressi automaticamente quando possibile).',
  sectionOtherClub: 'Altro fan club JOFC*',
  otherClubQ: 'Sei socio di un altro Juventus Official Fan Club?',
  otherClubYes: 'Sono socio di un altro fan club',
  otherClubNo: 'Non sono socio di un altro fan club',
  otherClubLegal:
    '<strong>Una persona può essere socio di un solo Juventus Official Fan Club.</strong> Se rispondi sì, devi chiedere personalmente al precedente club la cancellazione presso la Juventus. Ricevuta la richiesta, il club è tenuto a rimuoverti dall’elenco a Torino entro 24 ore.',
  importantUnsub:
    '⚠️ <strong>IMPORTANTE:</strong> Devi aver richiesto la disiscrizione al vecchio fan club prima di completare questa iscrizione.',
  checkboxUnsub: '✓ Ho richiesto la disiscrizione al mio precedente fan club',
  membershipChoiceTitle: 'TIPO DI ISCRIZIONE',
  eligibilityIntro: 'In base alla data di nascita:',
  eligUnder5: 'Hai diritto alla quota Under 5 (gratuita).',
  eligUnder14: 'Hai diritto alla quota Under 14.',
  eligAdult: 'Hai diritto alla quota JOFC Adult.',
  labelYourMembership: 'La tua quota*',
  membershipOptAdult:
    '<p><strong>JOFC Adult — 40 CHF / 40 €</strong></p><p>Incluso: Membership Black &amp; White digitale gratuita + un portachiavi</p>',
  membershipOptUnder14:
    '<p><strong>Under 14 — 30 CHF / 30 €</strong></p><p>(nati dopo il 01.07.2013)</p><p>Incluso: Membership Junior + un beanie</p>',
  membershipOptUnder5: '<p><strong>Under 5 — Gratuito (nati dopo il 01.07.2022)</strong></p>',
  membershipRightsNote:
    'I diritti dettagliati per formula saranno comunicati a breve.',
  sectionPriceTitle: 'Prezzi quota stagione 2026-2027',
  thPaymentMode: 'Modalità di pagamento',
  thAdult: 'JOFC Adult',
  thUnder14: 'Under 14',
  thUnder5: 'Under 5',
  thPriceChfEur: 'Prezzo CHF / Prezzo EUR',
  pricingRowEbanking: 'E-banking',
  pricingRowRevolut: '*Carta Revolut',
  pricingRowCredit: '*Carta di credito',
  tableNoteSms: '*Invia SMS o WhatsApp al +41786289688',
  twintCell: '(al 0786289688)',
  pricingUnder5Cell: 'Gratuito',
  labelPaymentMode: 'Modalità di pagamento *',
  selectPayment: 'Seleziona la modalità di pagamento',
  optGratuit: 'Gratuito (Under5)',
  optgroupEbanking: 'E-banking',
  optgroupTwint: 'Twint',
  optgroupRevolut: 'Carta Revolut',
  optgroupCredit: 'Carta di credito',
  optEbanking: 'E-banking (CHF o EUR)',
  optTwint: 'Twint (solo CHF)',
  optRevolut: 'Carta Revolut (CHF o EUR)',
  optCredit: 'Carta di credito (CHF o EUR)',
  labelCurrency: 'Valuta *',
  chfLabel: 'CHF (franchi svizzeri)',
  eurLabel: 'EUR (euro)',
  amountDue: 'Importo da pagare:',
  tesseraExtra: ' + 20 CHF/EUR per la Juventus Card',
  paymentInfoTitle: 'Informazioni di pagamento:',
  paymentTwintLi: 'Twint:',
  paymentTwintContact: '+41 78 628 96 88 (aggiungi ai contatti)',
  paymentIbanChf: 'IBAN CHF:',
  paymentIbanEur: 'IBAN EUR:',
  paymentBic: 'BIC:',
  paymentBenef: 'Beneficiario:',
  paymentBenefValue: 'Juventus Club Oltre Frontiera, 1820 Montreux',
  paymentRevolutNote:
    '📱 <strong>Per Carta Revolut e carta di credito:</strong> invia SMS o WhatsApp al +41786289688',
  sectionDischargeTitle: 'Liberatoria*',
  consentDischargePrev:
    'Iscrivendomi al JOFC Oltre Frontiera dichiaro che i dati sopra sono veritieri...',
  consentDischargeExp:
    'Iscrivendomi al JOFC Oltre Frontiera dichiaro che i dati sopra sono veritieri. In caso di falsificazione sollevo il JOFC Oltre Frontiera da ogni responsabilità se la Juventus decide di escludermi. La quota annuale versata non sarà rimborsata pro rata per la stagione in corso.',
  submitLoading: '⏳ Iscrizione in corso...',
  submitIdle: '✅ Conferma iscrizione',
  formNoteSubmit:
    'Cliccando su «Conferma iscrizione» confermi che i dati sono esatti e accetti le condizioni generali.',
  alreadyMember: 'Già socio?',
  linkLogin: 'Accedi',
  altSociImage: 'Soci',
  alertSuccess:
    'Iscrizione riuscita! Ti abbiamo appena inviato un’e-mail di conferma (noreply@oltrefrontiera.ch). Riceverai un secondo messaggio quando l’amministrazione avrà convalidato la pratica e il pagamento.',
  errorGenericSubmit: 'Si è verificato un errore durante l’iscrizione',
  errorPayloadTooLarge:
    "I file inviati superano il limite consentito dal server. Riprova con allegati più leggeri (ad es. foto a risoluzione ridotta o PDF compressi, max 15 MB ciascuno). Se il problema persiste, contatta il club: la configurazione del server deve consentire caricamenti più grandi (es. nginx: client_max_body_size).",
  errors: {
    civilite: 'Il titolo è obbligatorio',
    firstName: 'Il nome è obbligatorio',
    lastName: 'Il cognome è obbligatorio',
    sexe: 'Il sesso è obbligatorio',
    dateOfBirth: 'La data di nascita è obbligatoria',
    birthCountry: 'Il paese di nascita è obbligatorio',
    birthCity: 'La città di nascita è obbligatoria',
    phone: 'Il cellulare è obbligatorio',
    email: 'L’email è obbligatoria',
    password: 'La password è obbligatoria',
    passwordMismatch: 'Le password non coincidono',
    street: 'La via è obbligatoria',
    streetNumber: 'Il numero civico è obbligatorio',
    city: 'La città di residenza è obbligatoria',
    postalCode: 'Il CAP è obbligatorio',
    identityType: 'Il tipo di documento è obbligatorio',
    identityNumber: 'Il numero del documento è obbligatorio',
    identityExpiry: 'La scadenza del documento è obbligatoria',
    identityIssueDate: 'La data di emissione del documento è obbligatoria',
    identityIssueCanton: 'Il cantone o dipartimento di emissione è obbligatorio',
    identityIssueCity: 'Il comune o località di emissione è obbligatorio',
    identityFileF: 'La copia del documento (fronte) è obbligatoria',
    codiceItaly: 'Il codice fiscale è obbligatorio per i residenti in Italia',
    tesseraNumber: 'Il numero della Juventus Card è obbligatorio',
    tesseraExpiry: 'La scadenza della Juventus Card è obbligatoria',
    tesseraPIN: 'Il PIN della Juventus Card è obbligatorio',
    tesseraFile: 'La copia della Juventus Card è obbligatoria',
    tribune: 'La tribuna è obbligatoria',
    settore: 'Il settore è obbligatorio',
    fila: 'La fila è obbligatoria',
    posto: 'Il posto è obbligatorio',
    blackWhiteNumber: 'Il numero della carta Black & White è obbligatorio',
    blackWhiteExpiry: 'La scadenza della carta è obbligatoria',
    blackWhiteFile: 'La copia della carta è obbligatoria',
    parentEmail: 'L’email del genitore è obbligatoria',
    parentPhone: 'Il telefono del genitore è obbligatorio',
    parentFirstName: 'Il nome del genitore è obbligatorio',
    parentLastName: 'Il cognome del genitore è obbligatorio',
    parentIdentityFile: 'La copia del documento del genitore è obbligatoria',
    discharge: 'Devi accettare la liberatoria',
    membershipType: 'Devi scegliere un tipo di quota',
    paymentMethod: 'La modalità di pagamento è obbligatoria',
    otherFanClub: 'Rispondi alla domanda sull’altro fan club',
  },
};
